/** Deterministic color from a user ID for presence indicators. */
export function presenceColorFromUserId(userId) {
    const PRESENCE_COLORS = [
        "#e74c3c",
        "#3498db",
        "#2ecc71",
        "#f39c12",
        "#9b59b6",
        "#1abc9c",
        "#e67e22",
        "#e84393",
        "#00cec9",
        "#6c5ce7",
    ];
    let hash = 0;
    for (let i = 0; i < userId.length; i++) {
        hash = (hash * 31 + userId.charCodeAt(i)) | 0;
    }
    return PRESENCE_COLORS[Math.abs(hash) % PRESENCE_COLORS.length];
}
export const REALTIME_EVENTS = {
    MAP_CHANGE: "map:change",
    PARTY_MOVE: "party:move",
    MAP_NOTE_CHANGE: "map-note:change",
};
